<template>
    <h2 class="episode-modal-title">
        <template v-if="'create' === context">
            New Podcast Episode
        </template>
        <template v-else-if="! episode.title">
            Edit Podcast Episode
        </template>
        <template v-else>
            {{ episode.title }}
        </template>
    </h2>
</template>
<script>
export default {
    props: {
        context: {
            required: true,
            type: String,
        },
        episode: {
            required: true,
            type: Object,
        },
    },
};
</script>
